import { BaseEntity } from "../../core";

export class DeductibleMultimedia extends BaseEntity {
    public id: number;
    public documetType: string;
    public pathFile: string;
    public claim: number;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/deductibleMultimedia.ts